// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b3e28d04416e95a868dd","655":"ed631fca8064e38485bc"}[chunkId] + ".js";
};